<script setup>

const { modelValue } = defineProps({ modelValue: null })
const emit = defineEmits(['update:modelValue'])

const { setProtocol, setRootFolder, protocol_id } = useFilters()
const { getList } = useBaseEntity()
const { can } = useAuth()

const { $on, $off } = useNuxtApp()


onMounted(() => {
  $on('refresh-protocol-list', reloadProtocols)
  reloadProtocols()
})

onUnmounted(() => {
  $off('refresh-protocol-list', reloadProtocols)
})

const protocolList = ref([])

async function reloadProtocols() {
  protocolList.value = await getList('protocol', undefined, { rowsPerPage: -1, 'sortBy': 'id', 'descending': true }).catch(e => { return [] })
  let found = false
  if (protocolList.value.length > 0 && protocol_id?.value) {
    protocolList.value.map(p => {
      if (p.id === protocol_id.value) {
        setProtocol(p)
        found = true
        return
      }
    })
  }

  if (!found) {
    setProtocol(null)
  }
}

import links from './menu'

const allowedLinks = computed(() => {
  let enabled_links = links
  if (!protocol_id?.value) {
    // only return dashboard and email when no protocol is selected
    enabled_links = links.filter(l => ['dashboard', 'email'].includes(l.entity))
  }

  return enabled_links
    .filter(l => can(l.action, l.entity)) // remove unallowed links
    .map(l => {
      if (l?.links) {
        return { ...l, links: l.links.filter(l => can(l.action, l.entity)) }
      }
      return l
    }) // remove internal unallowed links
    .filter(l => l.links?.length ?? 1 !== 0)
})


async function updateProtocol(protocol) {
  if (!protocol) {
    setProtocol(null)
    return
  }

  setProtocol(protocol)
}

</script>
<template>
  <v-navigation-drawer :model-value="modelValue" @update:modelValue="e => emit('update:modelValue', e)" persistent app
    mobile-breakpoint="991" width="290" v-if="protocolList?.length">
    <v-list density="compact" class="mt-0 pt-0">

      <v-list-item class='pa-3 bg-primary' color="primary">

        <v-list-item-title class="title text-right">
          <!--div class="etmf"><strong>eTMFlex</strong></div-->
          <v-toolbar-title class="text-left">
            <!--v-img width="110" src='/tsh_logo.png' contain /-->
            <div class="etmflex"><strong>eTMFlex</strong></div>
          </v-toolbar-title>
        </v-list-item-title>
      </v-list-item>

      <v-divider />

      <v-list-item class='pa-2'>
        <CoreField :key="protocolList.length" :model-value="protocol_id" @update:selected="v => updateProtocol(v)"
          select
          :field="{ key: 'global_protocol_id', list: protocolList, type: 'list', label: 'Protocol', subtitle: 'sponsor.name', size: 12 }" />
      </v-list-item>

      <v-divider />

      <template v-for="(link, i) in allowedLinks" :key="link.entity">
        <v-list-group class='pa-0 ma-0' v-if="link?.links.length" no-action
          :prepend-icon="link?.icon">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" :id="`menu_activator_${link.entity}`" :title="link.text"
              :prepend-icon="link?.icon" />
          </template>
          <v-list-item :id="`menu_${link.entity}_${link.action}`" class='pa-0 ma-0' v-for="(link, id) in link.links"
            :key="link.entity" :title="link.text" :to="link.to" :prepend-icon="link?.icon" />
        </v-list-group>
        <v-list-item :id="`menu_${link.entity}_${link.action}`" v-else :title="link.text"
          :to="link.to?.value ?? link.to" link exact :prepend-icon="link?.icon" />
      </template>
    </v-list>

  </v-navigation-drawer>
</template>

<style>
.etmflex {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  margin: 0 auto;
  font-style: italic;
  height: 40px;
  line-height: 41px;
  font-size: 1.5em;
  opacity: 0.6;
}
</style>